import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Link from 'react-router/lib/Link';
import MaskInput from 'react-input-mask';
import { get } from 'Language';

class ProfileEdit extends Component {

    state = {
        first: '',
        last: '',
        addr1: '',
        addr2: '',
        gender: '',
        bod: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        sport: '',
        phone: '',
        long: '',
        lat: '',
        fitter: ''
    }

    componentWillMount() {
        const { getProfile, getCountries } = this.props;
        getProfile();
        getCountries();
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps.profile);
    }

    changeValue = (e) => {
        const nextState = {};
        const { name, value } = e.target;
        nextState[name] = value;
        this.setState(nextState);
    }

    submit = (e) => {
        e.preventDefault();
        const { profile, updateProfile } = this.props;
        updateProfile(this.state, profile.username);
    }

    render() {

        const { isWaiting } = this.props;

        return (
            <div className="panel-custom-wrapper">
                <div className="panel panel-custom">
                    <div className="panel-heading">
                        Profile Edit
                    </div>
                    <form onSubmit={this.submit}>
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_LNAME') }</label>
                                        <input
                                            value={this.state.last}
                                            onChange={this.changeValue}
                                            type="text"
                                            name="last"
                                            className="form-control form-custom"/>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xs-12">
                                    <label>{ get('PROFILE_FNAME') }</label>
                                    <input
                                        value={this.state.first}
                                        onChange={this.changeValue}
                                        type="text"
                                        name="first"
                                        className="form-control form-custom"/>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_GENDER') }</label>
                                        <select
                                            name="gender"
                                            value={this.state.gender}
                                            onChange={this.changeValue}
                                            className="form-control form-custom">
                                            <option value=""></option>
                                            <option value="male">MALE</option>
                                            <option value="female">FEMALE</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_BIRTHDATE') } (YYYY-MM-DD)</label>
                                        <MaskInput
                                            mask="9999-99-99"
                                            value={this.state.bod}
                                            onChange={this.changeValue}
                                            type="text"
                                            name="bod"
                                            className="form-control form-custom"
                                        />

                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_ADDR1') }</label>
                                        <input
                                            value={this.state.addr1}
                                            onChange={this.changeValue}
                                            type="text"
                                            name="addr1"
                                            className="form-control form-custom"/>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_ADDR2') }</label>
                                        <input
                                            value={this.state.addr2}
                                            onChange={this.changeValue}
                                            type="text"
                                            name="addr2"
                                            className="form-control form-custom"/>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_CITY') }</label>
                                        <input
                                            value={this.state.city}
                                            onChange={this.changeValue}
                                            type="text"
                                            name="city"
                                            className="form-control form-custom"/>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_STATE') }</label>
                                        <input
                                            value={this.state.state}
                                            onChange={this.changeValue}
                                            type="text"
                                            name="state"
                                            className="form-control form-custom"/>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_ZIP') }</label>
                                        <input
                                            value={this.state.zip}
                                            onChange={this.changeValue}
                                            type="text"
                                            name="zip"
                                            className="form-control form-custom"/>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_COUNTRY') }</label>

                                        <select
                                            name="country"
                                            value={this.state.country}
                                            onChange={this.changeValue}
                                            className="form-control form-custom">
                                            <option value=""></option>

                                            { this.props.countries.map(item => {
                                                return (
                                                    <option key={`countries_${item.id}`} value={item.id}>
                                                        { item.name }
                                                    </option>
                                                )
                                            })}

                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_PHONE') }</label>
                                        <input
                                            value={this.state.phone}
                                            onChange={this.changeValue}
                                            type="text"
                                            name="phone"
                                            className="form-control form-custom"/>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xs-12">
                                    <div className="form-group">
                                        <label>{ get('PROFILE_SPORT') }</label>

                                        <select
                                            name="sport"
                                            value={this.state.sport}
                                            onChange={this.changeValue}
                                            className="form-control form-custom">
                                            <option value=""></option>

                                            { this.props.sports.map(item => {
                                                return (
                                                    <option key={`sports_${item.id}`} value={item.id}>
                                                        { item.name }
                                                    </option>
                                                )
                                            })}

                                        </select>
                                    </div>
                                </div>
                            </div>
                            { parseInt(this.state.fitter, 10) === 1
                                ? <div className="row">
                                    <div className="col-md-6 col-xs-12">
                                        <div className="form-group">
                                            <label>{get('PROFILE_LONGITUDE')}</label>
                                            <input
                                                value={this.state.long}
                                                onChange={this.changeValue}
                                                type="text"
                                                name="long"
                                                className="form-control form-custom"/>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xs-12">
                                        <div className="form-group">
                                            <label>{get('PROFILE_LATITUDE')}</label>
                                            <input
                                                value={this.state.lat}
                                                onChange={this.changeValue}
                                                type="text"
                                                name="lat"
                                                className="form-control form-custom"/>
                                        </div>
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                        <div className="btn-custom text-right panel-footer">
                            <Link className="btn btn-primary" to="/profile">Cancel</Link>&nbsp;
                            <button className="btn btn-success" disabled={ isWaiting }>
                                { isWaiting
                                    ? 'Loading...'
                                    : 'Update'
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        const { profile, countries, sports } = state.profile;
        const { isWaiting } = state.onWaiting;


        return {
            profile, countries, sports, isWaiting
        }
    },
    actions
)(ProfileEdit)



// WEBPACK FOOTER //
// ./src/profile/containers/ProfileEdit.js